/* Importaciones propias */
import {ContactSection} from '../components/contact/ContactSection';

export const Contact = () => {
    return (
        <>
            <ContactSection/>
        </>
    )
}